import AppLogo from "../AppLogo";
import ChangeLangButton from "../language/ChangeLangButton";

export default function LogoWithLanguage() {
  return (
    <div className="w-full flex gap-2 justify-between flex-col md:flex-row items-start md:items-center">
      <AppLogo />
      <ChangeLangButton dropDownLanguage={true} />
    </div>
  );
}
